import { TrialProgramImage } from '@ui';
import { OrganType } from '@/api/apis/case';

export const TrialsCell = ({ trialCertificates }: { trialCertificates: OrganType[] }) => {
  if (!trialCertificates.length) {
    return <span>-</span>;
  }

  return (
    <div className="flex flex-col gap-1">
      {trialCertificates.map((organ) => (
        <TrialProgramImage key={organ} organ={organ} width={72} height={24} />
      ))}
    </div>
  );
};
